import React from 'react';
import PropTypes from 'prop-types';
import { getDashboardMenuConfig } from '@constants/config';
import NameDescriptionDialog from '@shared/dialogs/name-description-dialog';
import TaskTypeDiscardDialog from '@shared/dialogs/task-type-discard-dialog';
import TaskTypePublishDialog from '@shared/dialogs/task-type-publish-dialog';
import MenuSection from './menu-section';
import './dashboard.scss';

const Dashboard = ({ children }) => {
  const menuConfig = getDashboardMenuConfig();
  const menuSections = Array.isArray(menuConfig) ? menuConfig : [];

  return (
    <div styleName="dashboard-container">
      <nav aria-label="Section navigation" styleName="dashboard-menu-container">
        {menuSections.map(section => <MenuSection key={section.title} section={section} />)}
      </nav>
      <div styleName="dashboard-content">
        {children}
      </div>
      <NameDescriptionDialog />
      <TaskTypeDiscardDialog />
      <TaskTypePublishDialog />
    </div>
  );
};

Dashboard.propTypes = {
  children: PropTypes.element
};

export default Dashboard;
